import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class ExpenseServices {
  /**
      *
      * @param payload
      * @return {Promise<*>}
      */
  getExpense = async (tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword) => {
    let url = `${Constants.EXPENSE}?`;
    if (tenantId) url += `tenant_ids=${tenantId}&`;
    if (expenseId) url += `expense_id=${expenseId}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (departmentId) url += `seller_id=${departmentId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (status) url += `status=${status}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    const expense = await Helpers.get({ url });
    return expense;
  }

  /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     createExpense = async (payload) => {
       const expense = await Helpers.post({
         url: Constants.EXPENSE,
         data: payload,
       });
       return expense;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     updateExpense = async (payload) => {
       const expense = await Helpers.put({
         url: Constants.EXPENSE,
         data: payload,
       });
       return expense;
     }

     /**
      * @param payload
      * @return {Promise<*>}
      */
  getExpenseById = async (tenantId, expenseId) => {
    let url = `${Constants.EXPENSE}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (expenseId) url += `expense_id=${expenseId}&`;
    const expense = await Helpers.get({
      url: `${url}`,
    });
    return expense;
  }

     /**
     *
     * @param payload
     * @return {Promise<*>}
     */
     deleteExpense = async (payload) => {
       const deleteExpense = await Helpers.delete({
         url: Constants.EXPENSE,
         data: payload,
       });
       return deleteExpense;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
    linkExpense = async (payload) => {
      const linkExpense = await Helpers.post({
        url: Constants.EXPENSE_LINK,
        data: payload,
      });
      return linkExpense;
    }

    /**
     * @param expensePaymentId
     * @param {*} payload
     * @return
     */
    unLinkExpense = async (expensePaymentId) => {
      const unLinkPayment = await Helpers.delete({
        url: `${Constants.EXPENSE_UNLINK}${expensePaymentId ? `?expense_payment_id=${expensePaymentId}` : ''}`,
      });
      return unLinkPayment;
    }

    /**
      *
      * @param payload
      * @return {Promise<*>}
      */
  getAccount = async (tenantId, page, limit, searchKeyword) => {
    let url = `${Constants.ACCOUNT}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    const account = await Helpers.get({ url });
    return account;
  }

  /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     createAccount = async (payload) => {
       const account = await Helpers.post({
         url: Constants.ACCOUNT,
         data: payload,
       });
       return account;
     }

     /**
     *
     * @param payload
     * @return {Promise<*>}
     */
     updateAccount = async (payload) => {
       const account = await Helpers.put({
         url: Constants.ACCOUNT,
         data: payload,
       });
       return account;
     }

     /**
     *
     * @param payload
     * @return {Promise<*>}
     */
      deleteAccount = async (payload) => {
        const deleteAccount = await Helpers.delete({
          url: Constants.ACCOUNT,
          data: payload,
        });
        return deleteAccount;
      }
}

export default new ExpenseServices();
